require('./brokerMiFIDAllowDisclaimerAcceptingResponsability.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKMessage } = require('commonsComponents/OKMessage');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const CLASS_NAME = 'broker-mifid-allow-disclaimer-accepting-responsability';

class BrokerMiFIDAllowDisclaimerAcceptingResponsability extends React.Component {

    buildContentFinishedInformation() {
        const { clientEmail, resultText, disclaimerText } = this.props;

        return (
            <div>
                <h4 className={`${CLASS_NAME}__title`}>
                    <FormattedText value="broker-convenienceMifidTestOperateFinishingTest" />
                    <span className="ok-box-title__separator"></span>
                </h4>
                <div className={`${CLASS_NAME}__content-finished`}>
                    <OKBoxTitle
                        value={formatText('broker-convenienceMifidTestSuccessfullyFinished')}
                        isNotSeparator={true}
                    />
                    <div className="wizard-success-step__success-sub-message">
                        <span>
                            <FormattedText
                                value="broker-convenienceMifidTestAnswersSentToEmail"
                                injectedStrings={[clientEmail]}
                            />
                        </span>
                    </div>
                    <div>
                        <h4 className={`${CLASS_NAME}__result-title`}>
                            <FormattedText
                                format="uppercase"
                                value="broker-convenienceMifidTestResult"
                            />
                        </h4>
                        <h4 className={`${CLASS_NAME}__info ${CLASS_NAME}__info-bold`}>
                            {resultText}
                        </h4>
                        <div className={`${CLASS_NAME}__disclaimer-message`}>
                            <OKMessage type="informative">
                                {disclaimerText}
                            </OKMessage>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildContentOmitInformation() {
        const { resultText, disclaimerText } = this.props;
        const warningDisclaimerText = formatText('broker-convenienceMifidTestWarningDisclaimerText');

        return (
            <div>
                <h4 className={`${CLASS_NAME}__title`}>
                    <FormattedText value="broker-convenienceMifidTestOperateOmittingTest" />
                    <span className="ok-box-title__separator"></span>
                </h4>
                <div className={`${CLASS_NAME}__content`}>
                    <p className={`${CLASS_NAME}__info ${CLASS_NAME}__info-bold`}>
                        {resultText}
                    </p>
                    <div className={`${CLASS_NAME}__disclaimer-message`}>
                        <OKMessage type="informative">
                            {warningDisclaimerText}
                            {disclaimerText}
                        </OKMessage>
                    </div>
                </div>
            </div>
        );
    }

    buildFinishedSectionButtons() {
        const { onContinueOperation, onCancel } = this.props;
        return (
            <div className={`${CLASS_NAME}__content`}>
                <div className="wizard-success-step__separator" />
                <div className="wizard-success-step__foot-buttons text-right">
                    <div className="pull-left">
                        <OKButton onClick={onCancel} modifier="link-ghost">
                            <FormattedText value="broker-convenienceMifidTestCancel" />
                        </OKButton>
                    </div>
                    <OKButton onClick={onContinueOperation} modifier="secondary">
                        <FormattedText value="broker-convenienceMifidTestAcceptAndContinueOperation" />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildOmitSectionButtons() {
        const { onContinueOperation, onStartConvenienceMiFIDTest, onCancel } = this.props;
        return (
            <div className={`${CLASS_NAME}__content`}>
                <div className="wizard-success-step__separator" />
                <div className="wizard-success-step__foot-buttons text-right">
                    <div className="pull-left">
                        <OKButton onClick={onCancel} modifier="link-ghost">
                            <FormattedText value="broker-convenienceMifidTestCancel" />
                        </OKButton>
                    </div>
                    <div className={`${CLASS_NAME}__content__right`}>
                        <div className="pull-left">
                            <OKButton onClick={onStartConvenienceMiFIDTest} modifier="ghost">
                                <FormattedText value="broker-convenienceMifidTestGoToMakeTest" />
                            </OKButton>
                        </div>
                        <OKButton onClick={onContinueOperation} modifier="secondary">
                            <FormattedText value="broker-convenienceMifidOmitTestContinue" />
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            isTestOmitted
        } = this.props;

        let sectionButtons;
        let contentInformation;

        if (isTestOmitted) {
            sectionButtons = this.buildOmitSectionButtons();
            contentInformation = this.buildContentOmitInformation();
        } else {
            sectionButtons = this.buildFinishedSectionButtons();
            contentInformation = this.buildContentFinishedInformation();
        }

        return (
            <ContentBox>
                {contentInformation}
                {sectionButtons}
            </ContentBox>
        );
    }
}

BrokerMiFIDAllowDisclaimerAcceptingResponsability.propTypes = {
    clientEmail: PropTypes.string.isRequired,
    onContinueOperation: PropTypes.func.isRequired,
    disclaimerText: PropTypes.string.isRequired,
    resultText: PropTypes.string.isRequired,
    isTestOmitted: PropTypes.bool.isRequired,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

module.exports = BrokerMiFIDAllowDisclaimerAcceptingResponsability;
